import React, { useState } from 'react';
import { AccordionDetails, AccordionSummary, SvgIcon } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ReactComponent as ExpandMore } from 'assets/icons/arrow-down.svg';
import Link from '../../../../elements/Link';
import { StyledAccordion, StyledAccordionListItem } from './styles';

const DS_FooterBasicMenuMobile = ({ label, items }) => {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const handleAccordionChange = (event, isExpanded) => setExpandedPanel(isExpanded);

  return (
    <StyledAccordion expanded={expandedPanel} onChange={handleAccordionChange} disableGutters={true}>
      <AccordionSummary expandIcon={<SvgIcon component={ExpandMore} inheritViewBox />} aria-controls={label}>
        <Typography variant="DS_labelSmallBold">{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {items.map((item, index) => (
          <StyledAccordionListItem key={`${item.id}-${index}`} data-test="styled-list-item">
            <Link url={item.url} type={item.type}>
              {item.title}
            </Link>
          </StyledAccordionListItem>
        ))}
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default DS_FooterBasicMenuMobile;
